export enum ShipmentDutyOrTaxPaidBy {
  "SENDER" = "SENDER",
  "RECEIVER" = "RECEIVER",
}
